// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!components/ui/common.module.scss");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!./card.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, "._704bc2{--left-gutter: 4.5rem}.e0bb7b{margin-right:1rem;margin-bottom:var(--medium-spacer);height:120em;position:relative}.e0bb7b.e4b0ea{font-size:.9375em}@media print{.e0bb7b{height:114em}}._2934fd{position:absolute;top:0;right:0;bottom:0;left:0}._2934fd:not(.ba41e1){cursor:copy}.f2b149{position:absolute;top:0;left:var(--left-gutter);right:0;bottom:0;overflow:hidden}._422e17{display:flex;top:0;right:0;bottom:0;left:0;position:absolute}.d0a0a6,.c68e5e{transition:transform 200ms cubic-bezier(0.86, 0, 0.07, 1)}._9c8816{flex:1;position:relative}._9c8816+._9c8816{border-left:1px dashed var(--subtle)}.c4e84d .b55176,.fef6c0 .c68e5e{transform:translateX(-100%)}.fef6c0 .b55176,.c4e84d .c68e5e{transform:translateX(100%)}._814096.c4e84d.e18162 .b55176,._814096.fef6c0.e18162 .c68e5e{transform:translateX(-33.333%)}._814096.fef6c0.e18162 .b55176,._814096.c4e84d.e18162 .c68e5e{transform:translateX(33.333%)}._814096.c4e84d._9abfa8 .b55176,._814096.fef6c0._9abfa8 .c68e5e{transform:translateX(-66.666%)}._814096.fef6c0._9abfa8 .b55176,._814096.c4e84d._9abfa8 .c68e5e{transform:translateX(66.666%)}._814096.c4e84d.e18162 .c68e5e>:nth-child(-n+2),._814096.fef6c0.e18162 .c68e5e>:nth-child(n+2){opacity:0}._8f0b54{position:absolute;top:0;left:0;will-change:transform;z-index:999;transform:translate3d(0, 0, 0) scale(0)}.cd5d73{}._5349be{box-shadow:0 0 1em rgba(0,0,0,.15)}", ""]);
// Exports
exports.locals = {
	"wrapper": "_704bc2",
	"section": "e0bb7b",
	"size-7": "e4b0ea",
	"size7": "e4b0ea",
	"cards": "_2934fd",
	"locked": "ba41e1",
	"canvas": "f2b149",
	"columns": "_422e17 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["unselectable"] + "",
	"entering": "d0a0a6",
	"exiting": "c68e5e",
	"column": "_9c8816",
	"slide-left": "c4e84d",
	"slideLeft": "c4e84d",
	"exited": "b55176",
	"slide-right": "fef6c0",
	"slideRight": "fef6c0",
	"length-3": "_814096",
	"length3": "_814096",
	"slide-1-days": "e18162",
	"slide1Days": "e18162",
	"slide-2-days": "_9abfa8",
	"slide2Days": "_9abfa8",
	"ghostElement": "_8f0b54",
	"beginTime": "cd5d73 " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["beginTime"] + "",
	"card": "_5349be"
};
module.exports = exports;
